﻿import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';

export function setupEWIFSlider() {
    const $slider = $('.ewif-testimonials-slider');
    if (!$slider.length) {
        console.warn('Slider element .ewif-testimonials-slider not found');
        return;
    }

    // Calculate the maximum height of all slides
    const $slides = $slider.find('.swiper-slide');
    let maxHeight = 0;
    $slides.each(function () {
        const slideHeight = $(this).outerHeight();
        if (slideHeight > maxHeight) {
            maxHeight = slideHeight;
        }
    });

    // Apply the maximum height to all slides
    if (maxHeight > 0) {
        $slides.css('min-height', `${maxHeight}px`);
    }

    new Swiper('.ewif-testimonials-slider', {
        modules: [Navigation, Autoplay],
        slidesPerView: 1,
        spaceBetween: 30,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        loop: false,
        // Remove autoHeight to prevent dynamic resizing
        // autoHeight: true,
        speed: 1000,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false
        }
    });
}